import * as angular from 'angular';

export class GcmFactory {
    private apiRoot: string = '/api/v1/device/gcm';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    create(data: any) {
        return this.$http.post(
            `${this.apiRoot}/`,
            data
        );
    }
}

angular
    .module('app')
    .service('GcmFactory', GcmFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/gcm.factory.ts